import { getApiUrlFromBase } from './apiConfig';

const getApiUrl = (path = '') => {
  if (!path) {
    console.warn('getApiUrl fue llamado sin un path');
  }

  return getApiUrlFromBase(path);
};

export default getApiUrl;
  
